import {WlMonoSelect} from "./monoselect.component";
import {defineWebComponent} from "../webcomponents-utils";

export * from './monoselect.component';
export default WlMonoSelect;

defineWebComponent('wl-monoselect', WlMonoSelect);